import React from "react";
import { AddCircleOutline } from "@mui/icons-material";
import { useSimpleFormIteratorItem } from "react-admin";

type AddMemberProps = {
  onClick: (id: number) => void;
};

const AddMember: React.FC<AddMemberProps> = ({ onClick }) => {
  const { index } = useSimpleFormIteratorItem();

  return <AddCircleOutline onClick={() => onClick(index)} />;
};

export default AddMember;
